import * as React from 'react';
import { useEffect } from 'react';
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const shouldUseHardcodedValues = (ownerInloNo, energy) => {
  const ownerNo = String(ownerInloNo ?? "").trim();
  const energyCode = String(energy ?? "").trim().toUpperCase();
  return (
    (ownerNo === "11000" && energyCode === "AIR") ||
    (ownerNo === "14000" && energyCode === "STEAM")
  );
};

/* 공장대시보드 에너지절감량 */
export const FxDashChart4 = (props) => {
  const {
    energy,
    allValues,
    unit,
    ownerInloNo,
    hardcodedValues = {},
    chartHeight = 240,
  } = props;
  const resolvedValues = React.useMemo(() => {
    const sourceValues = allValues?.[energy];
    if (shouldUseHardcodedValues(ownerInloNo, energy)) {
      return hardcodedValues?.[energy] || [];
    }
    return sourceValues;
  }, [allValues, energy, ownerInloNo, hardcodedValues]);

  //console.log("*** FxDashChart4 ***", energy, "allValues", allValues);

  const makeSeries = (values) => {
    const series = [];
    const s = {};
    s.name = '현재';
    s.data = [];
    s.type = 'column';
    s.color = {
      linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
      stops: [
        [0, "#6fe8ff"],
        [1, "#2b8bff"],
      ],
    };
    s.zIndex = 2;
    s.tooltip = { valueSuffix: " " + unit };
    s.borderRadius = 4;

    const s2 = {};
    s2.name = 'BL';
    s2.data = [];
    s2.type = 'line';
    s2.color = '#ffd86b';
    s2.dashStyle = 'ShortDash';
    s2.lineWidth = 2.5;
    s2.zIndex = 3;
    s2.tooltip = { valueSuffix: " " + unit };
    s2.marker = {
      enabled: true,
      radius: 3,
      lineWidth: 1,
      lineColor: "#ffd86b",
      fillColor: "#2b2f3a",
    };

    if (values) {
      if (values !== undefined) {
        for (const value of values) {
          s.data.push(value.consAmt);
          s2.data.push(value.expConsAmt);
        }
      }
      series.push(s);
      series.push(s2);
    }

    return series;
  }
  

  const getCategories = (values) => {
    const categories = [];

    if (values) {
      if (values !== undefined) {
        for (const value of values) {
          categories.push(value.consMonth.substr(0, 4) + '.' + value.consMonth.substr(4, 5));
        }
      }
    }

    return categories;
  }

  const getChartData = (title) => {
    return {
      title: {
        text: title,
        align: "center",
      },

      tooltip: {
        crosshairs: true,
        shared: true,
        valueSuffix: " ",
        backgroundColor: "rgba(21, 28, 43, 0.95)",
        borderColor: "#4fc3f7",
        borderRadius: 8,
        borderWidth: 1,
        style: {
          color: "#eaf2ff",
          fontSize: "12px",
        },
        useHTML: true,
        formatter: function () {
          const lines = [
            `<span style="color:#9ec7ff;font-size:11px">${this.x || ""}</span>`,
          ];
          if (this.points) {
            this.points.forEach((point) => {
              lines.push(
                `<span style="color:${point.color}">●</span> ${point.series.name}: <b>${Highcharts.numberFormat(point.y || 0, 0)}</b> ${unit}`
              );
            });
          }
          return lines.join("<br/>");
        },
      },
      plotOptions: {
        series: {
          animation: {
            duration: 450,
          },
          cursor: 'pointer'
        },
        column: {
          borderWidth: 0,
          pointPadding: 0.05,
          groupPadding: 0.12,
          borderRadius: 4,
          maxPointWidth: 28,
          shadow: {
            color: "rgba(79, 195, 247, 0.35)",
            offsetX: 0,
            offsetY: 3,
            opacity: 0.4,
            width: 8,
          },
        },
        line: {
          marker: {
            enabled: true,
          }
        }
      },
      series: makeSeries(resolvedValues),
      xAxis: {
        categories: getCategories(resolvedValues),
        lineColor: "#48506a",
        tickColor: "#48506a",
        labels: {
          style: {
            color: "#b9c6e3",
            fontSize: "11px",
          },
        },
      },
      yAxis: {
        title: {
          text: null,
        },
        labels: {
          formatter: function () {
            return Highcharts.numberFormat(this.value || 0, 0);
          },
          style: {
            color: "#a9b4cc",
            fontSize: "11px",
          },
        },
        lineWidth: 1,
        lineColor: '#3e3e3e',
        gridLineColor: 'rgba(115, 128, 163, 0.3)',
        gridLineDashStyle: "ShortDot",
      },
      chart: {
        type: 'column',
        backgroundColor: "#2f3440",
        borderWidth: 0,
        borderColor: "#303030",
        plotBackgroundColor: "#2d323d",
        plotBorderWidth: 0,
        plotBorderColor: "#303030",
        spacingTop: 8,
        spacingBottom: 8,
      },
      credits: {
        enabled: false,
      },
      legend: {
        enabled: true,
        symbolRadius: 0,
        itemStyle: {
          color: '#fff',
          fontWeight: "700",
        },
      }
    };
  }


  useEffect(() => {
    const values = resolvedValues;
    if (values === undefined) {
      return;
    }
  }, [resolvedValues])


  return (
    <HighchartsReact
      containerProps={{
        style: {
          height: typeof chartHeight === "number" ? `${chartHeight}px` : chartHeight,
          width: "100%",
          borderRadius: "10px",
          overflow: "hidden",
        },
      }}
      highcharts={Highcharts}
      options={getChartData('', '', '', '')}
    />
  );
}
